import { ActionTypesFactory } from "../../utils";

export const GetBeneficiary = ActionTypesFactory("Beneficiary", "Get");
export const CreateBeneficiary = ActionTypesFactory("Beneficiary", "create");
export const GetByBeneficiary = ActionTypesFactory("Beneficiary", "ID");

export const getBeneficiary = (payload) => {
    return {
        type: GetBeneficiary?.REQUEST,
        payload,
    }
}

export const createBeneficiary = (payload) => {
    return {
        type: CreateBeneficiary?.REQUEST,
        payload,
    }
}

export const getByIdBeneficiary = (payload) => {
    return {
        type: GetByBeneficiary?.REQUEST,
        payload
    }
}

